import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UserMenu: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // 點擊外部關閉選單
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    // 模擬登出功能
    setIsOpen(false);
    // 這裡可以添加實際的登出邏輯
    console.log('用戶登出');
  };

  const menuItems = [
    {
      icon: '👤',
      label: '個人資料',
      action: () => {
        setIsOpen(false);
        console.log('查看個人資料');
      }
    },
    {
      icon: '📋',
      label: '歷史訂單',
      action: () => {
        setIsOpen(false);
        navigate('/order-history');
      }
    },
    {
      icon: '❤️',
      label: '我的收藏',
      action: () => {
        setIsOpen(false);
        console.log('查看收藏');
      }
    },
    {
      icon: '⚙️',
      label: '設定',
      action: () => {
        setIsOpen(false);
        console.log('開啟設定');
      }
    },
    {
      icon: '❓',
      label: '幫助中心',
      action: () => {
        setIsOpen(false);
        console.log('開啟幫助中心');
      }
    }
  ];

  return (
    <div className="relative" ref={menuRef}>
      {/* 用戶頭像按鈕 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-10 h-10 border-2 border-gray-300 hover:border-gray-400 text-gray-600 hover:text-gray-700 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-medium shadow-soft bg-white"
      >
        <span className="text-lg">👤</span>
      </button>

      {/* 下拉選單 */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-56 bg-white rounded-2xl shadow-strong border border-gray-100 py-2 z-50 animate-fade-in">
          {/* 用戶資訊 */}
          <div className="px-4 py-3 border-b border-gray-100">
            <div className="flex items-center">
              <div className="w-10 h-10 border-2 border-gray-300 rounded-full flex items-center justify-center text-gray-600 bg-white">
                <span className="text-lg">👤</span>
              </div>
              <div className="ml-3">
                <p className="text-sm font-semibold text-gray-800">歡迎回來</p>
                <p className="text-xs text-gray-500">user@example.com</p>
              </div>
            </div>
          </div>

          {/* 選單項目 */}
          <div className="py-1">
            {menuItems.map((item, index) => (
              <button
                key={index}
                onClick={item.action}
                className="w-full px-4 py-3 text-left flex items-center hover:bg-gray-50 transition-colors duration-200 group"
              >
                <span className="text-lg mr-3 group-hover:scale-110 transition-transform duration-200">
                  {item.icon}
                </span>
                <span className="text-sm text-gray-700 group-hover:text-blue-600 transition-colors duration-200">
                  {item.label}
                </span>
              </button>
            ))}
          </div>

          {/* 分隔線 */}
          <div className="border-t border-gray-100 my-1"></div>

          {/* 登出按鈕 */}
          <div className="px-4 py-1">
            <button
              onClick={handleLogout}
              className="w-full px-4 py-3 text-left flex items-center hover:bg-red-50 transition-colors duration-200 group rounded-xl"
            >
              <span className="text-lg mr-3 group-hover:scale-110 transition-transform duration-200">
                🚪
              </span>
              <span className="text-sm text-red-600 group-hover:text-red-700 transition-colors duration-200 font-medium">
                登出
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu; 